import { FormHelperText, Grid, InputLabel, Paper, Tooltip, Typography } from '@material-ui/core';
import { InputText } from '../../../../../../Core/Controls';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import DeleteIcon from '@material-ui/icons/Delete';
import SignaturePad from 'react-signature-canvas';
import { useContext } from 'react';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';

export const InSpectionSignOff = ({ classes }) => {
    const { state, useDefaultSig, clear, GetTechnicianSign, signCanvas, portalSettings, flags, handleInput } = useContext(InspectionCheCkContaxt);

    let TechnicianDeclaration = portalSettings.portalSettingTechnicianDeclaration.replace('{eventname}', flags.scheduleEventName);

    return (
        <>
            <Grid item xs={12} md={12}>
                <Paper className={classes.paper}>
                    <Grid container xs={12}>
                        <h3 className={classes.headings}>Vehicle Inspector</h3>
                    </Grid>

                    <Grid container xs={12}>
                        <div
                            className={classes.headings}
                            style={{ marginTop: -20 }}
                            dangerouslySetInnerHTML={{ __html: TechnicianDeclaration }}
                            // dangerouslySetInnerHTML={{ __html: portalSettings.portalSettingTechnicianDeclaration }}
                        />
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <div style={{ display: 'flex', alignItems: 'center', minHeight: 28, marginBottom: 4 }}>
                                <InputLabel shrink style={{ margin: 0 }}>
                                    Vehicle Checker Comment
                                </InputLabel>
                            </div>
                            <InputText
                                multiline
                                rows={8}
                                placeholder="Vehicle checker comment"
                                name="vehicleInspectionInspectionComment"
                                onChange={handleInput}
                                value={state.vehicleInspectionInspectionComment}
                                fullWidth
                                InputProps={{
                                    style: {
                                        height: 200,
                                        alignItems: 'flex-start'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        height: '100%',
                                        boxSizing: 'border-box'
                                    }
                                }}
                            />
                            <FormHelperText error>{state.errors?.vehicleInspectionInspectionComment}</FormHelperText>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 28, marginBottom: 4 }}>
                                <InputLabel shrink style={{ margin: 0, display: 'inline-flex', alignItems: 'center' }}>
                                    Signature
                                    {state.signAvailable ? (
                                        <Tooltip title="Use default signature">
                                            <BorderColorIcon
                                                onClick={useDefaultSig}
                                                style={{ cursor: 'pointer', marginLeft: 6, fontSize: 18 }}
                                            />
                                        </Tooltip>
                                    ) : null}
                                </InputLabel>
                                <Tooltip title="Clear Signature">
                                    <DeleteIcon
                                        onClick={clear}
                                        style={{ cursor: 'pointer', fontSize: 20, color: 'rgba(0, 0, 0, 0.54)' }}
                                    />
                                </Tooltip>
                            </div>

                            {state.imgtechniciansign ? (
                                <div
                                    className="sigContainer"
                                    style={{
                                        height: 200,
                                        borderRadius: 4,
                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                        boxSizing: 'border-box',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <img
                                        src={state.techniciansign}
                                        alt="my signature"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'contain',
                                            display: 'block'
                                        }}
                                    />
                                </div>
                            ) : (
                                <div
                                    className="sigContainer"
                                    style={{
                                        height: 200,
                                        borderRadius: 4,
                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                        boxSizing: 'border-box',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <SignaturePad
                                        ref={signCanvas}
                                        canvasProps={{ className: 'sigPad' }}
                                        onEnd={() => {
                                            GetTechnicianSign();
                                        }}
                                    />
                                </div>
                            )}
                            <FormHelperText error>{state.errors?.techniciansign}</FormHelperText>
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <h5 className={classes.headings} style={{ height: 20 }}>
                            &nbsp;
                        </h5>
                    </Grid>
                </Paper>
            </Grid>
        </>
    );
};
